<!--行业管理-->
<template>
    <div class="industrie">
        <datePicker ref="starDatepicker" @selectDate="selectBgDateStar" type="day"></datePicker>
        <datePicker ref="endDatepicker" @selectDate="selectBgDateEnd" type="day"></datePicker>
        <div :style="getBackgroudImageStyle('huanbao/jpfaGuanLi/background.png')" class="industrieInhalt" v-show="isShow">
            <!--筛选框-->
            <div class="industrieScreening">
                <div class="conditionTime">
                    <span class="spanBlue">创建时间:</span>
                    <div @click="$refs.starDatepicker.show()">
                        <span>{{ startTime }}</span>
                    </div>
                    <span style="padding-left: .1rem;">到</span>
                    <div @click="$refs.endDatepicker.show()">
                        <span>{{ endTime }}</span>
                    </div>
                </div>
                <div class="conditionName">
                    <span class="spanBlue">行业名称:</span>
                    <input type="text" placeholder="行业名称" v-model="industriesousName" />
                    <img :src="getResourcesByName('/huanbao/jpfaGuanLi/searchFor.png')" @click="searchFor()" />
                </div>
            </div>
            <!--内容查看-->
            <div class="industrieInhaltBottom">
                <paginierung @changePage="changePageData" :titleList="titleList" :dataList="dataList" :pageNum="pageNum" :currentPage="pageIndex" @add="add" @edit="edit" @delete="strikeOut">
                    <tr :key="index" v-for="(item, index) in dataList">
                        <td>{{ index + 1 }}</td>
                        <td><input type="checkbox" :id="checkboxId(index)" :value="item.pkid" class="teCheckbox" /> {{ item.name }}</td>
                        <td>{{ item.memo }}</td>
                        <td>{{ new Date(item.createTime).format("yyyy-MM-dd hh:mm:ss") }}</td>
                    </tr>
                </paginierung>
            </div>
        </div>
        <!--添加与修改-->
        <div class="saveAndAdd" v-show="!isShow" :style="getBackgroudImageStyle('industrie/addBack.png')">
            <p>添加行业</p>
            <div class="saveAndAddContent">
                <div class="inputItem">
                    <span>行业名称:</span>
                    <input type="text" v-model="industryName" placeholder="行业信息" />
                    <span>(必填)*</span>
                </div>
                <div class="inputItem">
                    <span>备注:</span>
                    <textarea placeholder="备注" v-model="industryMome"></textarea>
                </div>
                <div class="buttonContent">
                    <button @click="save()">保存</button>
                    <button @click="isShow = true">返回</button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import paginierung from "@/components/module/huanbao/paginierung.vue"
import datePicker from "@/components/module/universal/datePicker.vue"
export default {
    components: {
        paginierung,
        datePicker
    },
    props: {},
    data() {
        return {
            titleList: ["序号", "行业名称", "备注", "创建时间"],
            isShow: true,
            dataList: [],
            industryName: "",
            industryMome: "",
            pageIndex: 1,
            pageSize: 10,
            pageNum: 0, //总页数
            selectItem: {
                pkid: ""
            },
            startTime: "开始时间",
            endTime: "结束时间",
            industriesousName: ""
        }
    },
    created() {},
    mounted() {
        this.initData()
    },
    destroyed() {},
    computed: {
        getBackgroudImageStyle() {
            return this.$store.resourcesStore.getters.getBackgroudImageStyle
        },
        getResourcesByName() {
            return this.$store.resourcesStore.getters.getResourcesByName
        },
        checkboxId() {
            return i => {
                return "checkbox" + i
            }
        }
    },
    watch: {},
    methods: {
        save() {
            if (this.industryName == "") {
                this.$dialogMethod.showMessage("行业名称不能为空")
                return
            }
            //保存
            this.$api.unitApi.saveIndustry(this.selectItem.pkid, this.industryName, this.industryMome, respon => {
                this.$dialogMethod.showMessage("保存成功")
                this.isShow = true
            })
		},
		changePageData(index){
			this.pageIndex = index
			this.initData()
		},
        initData() {
            //初始化数据
            this.$api.unitApi.getIndustryLimit(this.pageIndex, this.pageSize, "", "", "", respon => {
                this.dataList = respon.dataList
                if (respon.total != 0) {
                    this.pageNum = Math.ceil(respon.total / this.pageSize)
                }
            })
        },
        prePage() {
            //上一页
            this.pageIndex -= 1
            this.initData()
        },
        nextPage() {
            //下一页
            this.pageIndex += 1
            this.initData()
        },
        add() {
            this.isShow = false
             this.industryName = ''
            this.industryMome = ''
            this.selectItem = {
                pkid: ""
            }
            this.initData()
        },
        edit(item) {
            this.industryName = item.name
            this.industryMome = item.memo
            this.selectItem = item
            this.isShow = false
            this.initData()
        },
        strikeOut(item) {
            //删除
            this.$api.unitApi.deleteIndustry(item.pkid, respon => {
                this.$dialogMethod.showMessage(respon)
                this.initData()
            })
        },
        selectBgDateStar(date) {
            this.startTime = new Date(date).format("yyyy-MM-dd")
            this.$refs.starDatepicker.hide()
        },
        selectBgDateEnd(date) {
            this.endTime = new Date(date).format("yyyy-MM-dd")
            this.$refs.endDatepicker.hide()
        },
        searchFor() {
            if (this.startTime == "开始时间" || this.endTime == "结束时间") {
                this.$dialogMethod.showMessage("时间不能为空")
            }
            let startTime = new Date(this.startTime).getTime()
            let endTime = new Date(this.endTime).getTime()
            if (endTime - startTime < 0) {
                this.$dialogMethod.showMessage("开始时间不能大于结束时间")
            }
            //搜索
            this.$api.unitApi.getIndustryLimit(this.pageIndex, this.pageSize, startTime, endTime, this.industriesousName, respon => {
                this.dataList = respon.dataList
                if (respon.total != 0) {
                    this.pageNum = (respon.total - (respon.total % this.pageSize)) / this.pageSize + 1
                }
            })
        }
    }
}
</script>

<style scoped>
.spanBlue {
    color: #139ae6;
    white-space: nowrap;
}
.conditionName .spanBlue {
    width: 0.6rem;
}
.conditionName img {
    height: 0.32rem;
    margin-left: 0.04rem;
}
.industrie {
    width: 100%;
    height: 100%;
    display: flex;
}

.industrieScreening {
    width: 90%;
    margin: 0 auto;
    margin-top: 3.2%;
    display: flex;
    align-items: center;
    margin-bottom: 0.1rem;
}
/*条件过滤*/

.conditionTime {
    width: 40%;
    display: flex;
    align-items: center;
}

.conditionTime div {
    border: 0.01rem solid #d8d8d8;
    width: 30%;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 0.3rem;
    margin-left: 0.1rem;
}

.conditionTime div span {
    color: #d8d8d8;
}

.conditionName {
    width: 40%;
    display: flex;
    align-items: center;
    justify-content: space-around;
}

.conditionName input {
    width: 56%;
}

.industrieInhalt {
    width: 98%;
    height: 95%;
    margin: 0 auto;
    margin-top: 0.1rem;
}

.industrieInhaltBottom {
    width: 90%;
    height: 84%;
    margin: 0 auto;
}

.saveAndAdd {
    width: 98%;
    height: 40%;
    margin: 0 auto;
    margin-top: 0.5rem;
}

.saveAndAdd p {
    margin-top: 0.5rem;
    margin-left: 0.4rem;
}

.saveAndAddContent {
    width: 60%;
    height: 65%;
    margin: 0 auto;
    margin-top: 0.1rem;
}

.inputItem {
    width: 100%;
    margin-top: 0.1rem;
    display: flex;
}

.inputItem:nth-child(1) {
    align-items: center;
}

.inputItem input {
    width: 70%;
    margin-left: 0.2rem;
}

.inputItem textarea {
    width: 70%;
    margin-left: 0.5rem;
}

.inputItem span {
    color: #eb6263;
    padding-left: 0.1rem;
}

.inputItem span:nth-child(1) {
    color: #139ae6;
}

.buttonContent {
    height: 20%;
    width: 20%;
    display: flex;
    align-items: center;
    justify-content: space-around;
    margin-left: 0.8rem;
    margin-top: 0.2rem;
}

.buttonContent button {
    width: 40%;
    height: 70%;
    color: white;
}

.buttonContent button:nth-child(1) {
    background-color: #1696e4;
}

.buttonContent button:nth-child(2) {
    background-color: #dd4d4e;
}
</style>
